import { render, staticRenderFns } from "./TotalsCompareChart.vue?vue&type=template&id=8f9de0a2&lang=html&"
import script from "./TotalsCompareChart.vue?vue&type=script&lang=js&"
export * from "./TotalsCompareChart.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports